import { ReactNode } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { useStyles } from "./AuthNavigationContainerStyles";

interface IAuthNavigationContainerProps extends RouteComponentProps {
  children: ReactNode;
}

const AuthNavigationContainer = ({
  children,
}: IAuthNavigationContainerProps) => {
  const classes = useStyles();

  return <div className={classes.authNavigationText}>{children}</div>;
};

export default withRouter(AuthNavigationContainer);
